import React, { useState, useContext, useEffect } from 'react'
import { useRequest } from 'ahooks'

import { Stack, Skeleton } from '@mui/material'
import { getOrderList } from '@/api'
import { Pagination } from '@cx/ui'
import { AuthContext } from '@/layout/Auth'
import ReceiptModal from './ReceiptModal'
import ApplyInvoiceModal from './ApplyInvoiceModal'
import OrderCard from './OrderCard'

const Order = () => {
  const [receiptModalVisible, setReceiptModalVisible] = useState(false)
  const [applyInvoiceModalVisible, setApplyInvoiceModalVisible] = useState(false)
  const [size, setSize] = useState<number>(10)
  const [page, setPage] = useState<number>(1)
  const [total, setTotal] = useState<number>(0)
  const [currentOrder, setCurrentOrder] = useState<any>(null)
  const { authInfo } = useContext(AuthContext)
  const org_id = authInfo?.orgInfo?.id

  const { data, run, loading, refresh } = useRequest(
    () => {
      return getOrderList({ page, size, org_id: org_id! })
    },
    {
      manual: true,
      onSuccess: (res) => {
        document.getElementById('space-scroll')?.scrollTo({ top: 0 })
        setTotal(res?.total)
      },
    },
  )

  const onPaginationChange = (page: number, size: number) => {
    setPage(page)
    setSize(size)
  }

  useEffect(() => {
    if (authInfo?.orgInfo?.id) {
      run()
    }
  }, [authInfo?.orgInfo?.id, page, size])

  return (
    <Stack gap={3}>
      <ReceiptModal
        url={currentOrder?.receipt_url}
        open={receiptModalVisible}
        onCancel={() => setReceiptModalVisible(false)}
      />
      <ApplyInvoiceModal
        data={currentOrder}
        open={applyInvoiceModalVisible}
        onCancel={() => setApplyInvoiceModalVisible(false)}
        onOk={() => {
          setApplyInvoiceModalVisible(false)
          refresh()
        }}
      />
      <Stack gap={3}>
        {loading ? (
          <>
            <Skeleton variant='rounded' width='100%' height={420} />
            <Skeleton variant='rounded' width='100%' height={420} />
            <Skeleton variant='rounded' width='100%' height={420} />
          </>
        ) : (
          data?.detail.map((item) => {
            return (
              <OrderCard
                key={item.order_code}
                item={item}
                setApplyInvoiceModalVisible={setApplyInvoiceModalVisible}
                setReceiptModalVisible={setReceiptModalVisible}
                setCurrentOrder={setCurrentOrder}
              />
            )
          })
        )}
      </Stack>

      <Pagination total={total} page={page} pageSize={size} onChange={onPaginationChange}></Pagination>
    </Stack>
  )
}

export default Order
